import { useState } from "react";
import { faqs } from "@/mocks/feed";
import SectionHeading from "./SectionHeading";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="w-full bg-background-50">
      <div className="mx-auto grid w-full max-w-[1200px] gap-8 px-4 py-12 md:px-6 md:py-16 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-24">
            <SectionHeading
              eyebrow="前线问答"
              title="关于吃瓜前线"
              desc="这里是关于平台定位、更新频率、投稿方式与内容可靠性的高频疑问，帮助你更快上手蹲第一现场。"
            />
          </div>
        </div>

        <div className="lg:col-span-8">
          <div className="flex flex-col gap-3">
            {faqs.map((f, i) => {
              const open = openIdx === i;
              return (
                <div
                  key={f.q}
                  className={`overflow-hidden rounded-xl border bg-background-50 transition-colors ${
                    open ? "border-primary-300" : "border-background-200"
                  }`}
                >
                  <h3>
                    <button
                      type="button"
                      onClick={() => setOpenIdx(open ? -1 : i)}
                      aria-expanded={open}
                      className="flex w-full items-center gap-3 px-5 py-4 text-left cursor-pointer"
                    >
                      <span
                        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-sm font-bold ${
                          open ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-secondary-800"
                        }`}
                      >
                        {i + 1}
                      </span>
                      <span className="flex-1 text-sm font-semibold text-foreground-950 md:text-base">{f.q}</span>
                      <i
                        className={`ri-add-line text-xl text-foreground-500 transition-transform duration-300 ${open ? "rotate-45" : ""}`}
                        aria-hidden="true"
                      ></i>
                    </button>
                  </h3>
                  <div className={`grid transition-all duration-300 ${open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}>
                    <div className="overflow-hidden">
                      <p className="border-t border-background-200 px-5 py-4 pl-[60px] text-sm leading-relaxed text-foreground-600">
                        {f.a}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}